const childGridContainerEls = document.querySelectorAll('.child-grid-container');
if (childGridContainerEls) {
	childGridContainerEls.forEach((container) => {
		const extraChildGridItemEls = container.querySelectorAll('.extra-child-grid-item');
		const seeAllTriggerEl = container.querySelector('.js-see-all-child-grid');

		if (seeAllTriggerEl) {
			seeAllTriggerEl.addEventListener('click', (event) => {
				event.preventDefault();
				event.stopPropagation();
				const target = event.currentTarget;
				extraChildGridItemEls.forEach((item) => {
					item.classList.remove('hidden');
				});
				target.remove();
			});
		}
	});
}
